import { render } from "./menu-icon.svg?vue&type=template&id=2e880d47"
import script from "./menu-icon.svg?vue&type=script&lang=js"
export * from "./menu-icon.svg?vue&type=script&lang=js"

import exportComponent from "/codebuild/output/src222/src/s3/00/src/web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__